import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=58f4da0e&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&id=58f4da0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4da0e",
  null
  
)

export default component.exports